<template>
    <v-dialog
        v-model="$store.state.dispatch.productCompartments"
        hide-overlay
        persistent
        max-width="1400px"
        transition="dialog-bottom-transition"
    >
        <v-card>
            <v-container fluid>
                <v-row>
                    <v-col cols="7">
                        <div>
                            <v-card-title>
                                <p style="margin: 0 auto;">Product Information</p>
                            </v-card-title>

                            <v-simple-table dense>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-center">
                                                Order ID
                                            </th>
                                            <th class="text-center">
                                                Product ID
                                            </th>
                                            <th class="text-center">
                                                Product
                                            </th>
                                            <th class="text-center">
                                                Disp Qty Before Comps
                                            </th>
                                            <th class="text-center">
                                                Disp Qty After Comps
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(prd, index) in GroupedProducts"
                                            :key="index"
                                        >
                                            <td class="text-center">{{ prd.OrderID }}</td>
                                            <td class="text-center">{{ prd.ProductID }}</td>
                                            <td class="text-center">{{ prd.Product }}</td>
                                            <td class="text-center">{{ prd.DispatchedQuantity }}</td>
                                            <td class="text-center">{{ prd.QtyAfterComps }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                        <div>
                            <v-card-title>
                                <p style="margin: 0 auto;">Site Readings</p>
                            </v-card-title>

                            <v-simple-table dense>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-center">
                                                Site #
                                            </th>
                                            <th class="text-center">
                                                Tank #
                                            </th>
                                            <th class="text-center">
                                                Product
                                            </th>
                                            <th class="text-center">
                                                Volume
                                            </th>
                                            <th class="text-center">
                                                SafeFill
                                            </th>
                                            <th class="text-center">
                                                Ullage
                                            </th>
                                            <th class="text-center">
                                                Reading Time
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(rd, index) in CurrentReadings"
                                            :key="index"
                                        >
                                            <td class="text-center">{{ rd.SiteNum }}</td>
                                            <td class="text-center">{{ rd.TankNum }}</td>
                                            <td class="text-center">{{ rd.Product }}</td>
                                            <td class="text-center">{{ rd.Volume }}</td>
                                            <td class="text-center">{{ rd.Safefill }}</td>
                                            <td
                                                class="text-center"
                                                style="background: #F9f2aa;font-style: bold;"
                                            >
                                                <strong>{{ rd.Ullage }}</strong>
                                            </td>
                                            <td class="text-center">{{ rd.DateTime }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                    </v-col>
                    <v-col cols="5">
                        <div>
                            <v-card-title>
                                <p style="margin: 0 auto;">Product Compartments</p>
                            </v-card-title>

                            <v-simple-table dense>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-center">
                                                Comp Number
                                            </th>
                                            <th class="text-center">
                                                Comp Virtual Capacity
                                            </th>
                                            <th class="text-center">
                                                Comp Capacity
                                            </th>
                                            <th class="text-center">
                                                Product Stored
                                            </th>
                                            <th class="text-center">
                                                Product Quantity
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(comp, index) in ProductDistribution"
                                            :key="index"
                                        >
                                            <td class="text-center">{{ comp.Comp }}</td>
                                            <td
                                                class="text-center"
                                                :style="comp.Capacity != comp.VirtualCapacity ? 'background-color: #A4F4FF;' : 'background-color: transparent;'"
                                            >
                                                {{ comp.VirtualCapacity }}
                                            </td>
                                            <td class="text-center">{{ comp.Capacity }}</td>
                                            <td class="text-center">{{ comp.Product == null ? 'not apply' : comp.Product }}</td>
                                            <td class="text-center">{{ comp.Quantity == null ? 'not apply' : comp.Quantity }}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td class="text-center" style="background-color: #B7EBC4;">
                                                {{ TotalsPrdDist.Totals }}
                                            </td>
                                            <td class="text-center" style="background-color: #E5E7E9;">
                                                {{ TotalsPrdDist.TotalVirtualCapacity }}
                                            </td>
                                            <td class="text-center" style="background-color: #E5E7E9;">
                                                {{ TotalsPrdDist.TotalCompCapacity }}
                                            </td>
                                            <td class="text-center" style="background-color: #E5E7E9;"></td>
                                            <td class="text-center" style="background-color: #E5E7E9;">
                                                {{ TotalsPrdDist.TotalPrdQty }}
                                            </td>
                                        </tr>
                                    </tfoot>
                                </template>
                            </v-simple-table>
                        </div>
                    </v-col>
                </v-row>
            </v-container>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="closeProductCompartments"
                >
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
// Imports here

export default {
    props: ['ProductDistribution', 'GroupedProducts', 'CurrentReadings', 'TotalsPrdDist'],
    components: {

    },
    data: function () {
        return {
            //variables: [],
            //here: true,
            //...
        }
    },
    mounted() {
        //this.functionsForMountedHere();
    },
    methods: {
        closeProductCompartments: function() {
            this.$emit('close');
            this.$store.state.dispatch.productCompartments = false;
        },
    },
};
</script>

<style>
/* Styles here */
</style>